import angular from 'angular';
import { confirmDialog, alerts } from 'app/components/global';
import {
  loaderService,
  utilityService,
  ssDialogService,
  pmDataService,
  pmSharedModelService,
} from 'app/services';
import changeLogItemDirective from './change-log-item.directive';
import changeLogItemController from './change-log-item.controller';
import editChangeLogAttributesDialog from '../../dialog.editChangeLogAttributesDialog';

export default angular.module('app.components.advisory.pm.changeLog.changeLogItem', [
  alerts,
  loaderService,
  utilityService,
  ssDialogService,
  confirmDialog,
  editChangeLogAttributesDialog,
  pmDataService,
  pmSharedModelService,
])
  .directive('pmChangeLogItem', changeLogItemDirective)
  .controller('PmChangeLogItemController', changeLogItemController)
  .name;

console.log('app.components.advisory.pm.changeLog.changeLogItem created');
